<!--待打单-->
<template>
    <div id="printOrder">
        <Breadcrumb></Breadcrumb>
        <div class="form-body">
            <el-form :model="form" ref="form" class="form">
                <div class="form-border-div">
                    <el-form-item label="平台渠道:"  class="init-line-height">
                        <el-radio-group v-model="form.channel"   class="hide_input" @change="platChange">
                            <el-radio v-for="item in platList" :label="item.platNo">{{item.platName}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="店铺账号:" class="init-line-height">
                        <el-radio-group v-model="form.account" class="hide_input" @change="shopChange">
                            <el-radio label="all">全部</el-radio>
                            <el-radio v-for="item in accList" :label="item.shopId">{{item.shopName}} ({{item.platName}})</el-radio>
                            <el-radio label="manual">手工订单</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <div class="form-border-div">
<!--                    <el-form-item label="订单状态:" class="init-line-height">-->
<!--                        <el-radio-group v-model="form.status" class="hide_input" @change="getList">-->
<!--                            <el-radio label="all">全部</el-radio>-->
<!--                            <el-radio v-for="item in stateList" :label="item.dictValue">{{item.dictLabel}}</el-radio>-->
<!--                        </el-radio-group>-->
<!--                    </el-form-item>-->
                    <el-form-item label="国家区域:" class="init-line-height country-form-item">
                        <div style="width: 100%">
                            <!--                                    //默认显示的国家-->
                            <!--                                    <el-checkbox-group v-model="form.country" v-show="defaultFlag"  @change="checkCountries" class="hide_input">-->
                            <!--                                        <el-checkbox label="all">全部</el-checkbox>-->
                            <!--                                        <el-checkbox v-for="item in defaultCountries" :label="item"></el-checkbox>-->
                            <!--                                    </el-checkbox-group>-->
                            <!--                                    <el-form-item label="平台渠道:"  class="init-line-height">-->
                            <el-radio-group v-model="form.country"  v-show="defaultFlag" class="hide_input" @change="getList">
                                <el-radio label="all">全部</el-radio>
                                <el-radio v-for="item in defaultCountries" :label="item">{{item}}</el-radio>
                            </el-radio-group>
                            <!--                                    </el-form-item>-->


                            <!--                                    单选国家-->
                            <div style="width: calc(100% - 20px);height: 300px;border: 1px solid #EBEEF5;" v-show="radioFlag">
                                <div style="background-color: #eaeaea;width: 100%;height: 40px;display: flex;justify-content: space-between;align-items: center">
                                    <el-radio-group v-model="moreCountry" @change="moreCountryTypeChange" class="hide_input">
                                        <el-radio label="0">全部</el-radio>
                                        <el-radio label="1">欧洲</el-radio>
                                        <el-radio label="2">北美</el-radio>
                                        <el-radio label="3">南美</el-radio>
                                        <el-radio label="4">亚洲</el-radio>
                                        <el-radio label="5">大洋洲</el-radio>
                                        <el-radio label="6">非洲</el-radio>
                                        <el-radio label="7">其他</el-radio>
                                    </el-radio-group>
                                    <el-input size="small" suffix-icon="el-icon-search" @input="c_countryChange" style="width: 200px;" v-model="fieldFilter"></el-input>
                                </div>
                                <div class="cun_b_z">
                                    <el-radio-group v-model="moreCountrySelect" id="countryList"  class="hide_input" @change="countrySelClick" style="height:250px;overflow: auto">
                                        <el-radio v-for="item in countries" :label="item.countryCh" :value="item.code"></el-radio>
                                    </el-radio-group>
                                </div>
                            </div>


                            <!--                                    多选国家-->
                            <div style="width: calc(100% - 20px);height: auto;border: 1px solid #EBEEF5;" v-show="multiFlag">
                                <div style="background-color: #eaeaea;width: 100%;height: 40px">
                                    <el-radio-group v-model="moreCountry" @change="moreCountryTypeChange" class="hide_input">
                                        <el-radio label="0">全部</el-radio>
                                        <el-radio label="1">欧洲</el-radio>
                                        <el-radio label="2">北美</el-radio>
                                        <el-radio label="3">南美</el-radio>
                                        <el-radio label="4">亚洲</el-radio>
                                        <el-radio label="5">大洋洲</el-radio>
                                        <el-radio label="6">非洲</el-radio>
                                        <el-radio label="7">其他</el-radio>
                                    </el-radio-group>
                                    <el-input size="small" suffix-icon="el-icon-search" style="width: 200px;float: right;margin-right: 20px" v-model="fieldFilter"></el-input>
                                </div>
                                <div class="cun_b_z ">
                                    <el-checkbox-group v-model="moreCountrySelect2" @change="countrySelChange" class="hide_input" style="height:150px;overflow: auto">
                                        <el-checkbox v-for="item in countries" :label="item.countryCh"></el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div style="display: flex;background-color: rgb(234, 234, 234)">
                                    <div style="width: 100px">已选国家/地区</div>
                                    <div style="width: calc(100% - 100px);height:100px;">

                                        <div class="cun_b_z ">
                                            <el-checkbox-group v-model="allSelectedCountry" @change="allSelectedCountryChange"  class="hide_input" style="height:150px;overflow: auto">
                                                <el-checkbox v-for="item in checkedCountry" :label="item" :checked="true" ></el-checkbox>
                                            </el-checkbox-group>
                                        </div>

                                    </div>
                                </div>
                                <div style="text-align: center">
                                    <el-button size="small" type="primary" @click="saveMultiSelect"  >确认</el-button>
                                    <el-button size="small" @click="cancelMultiSelect">取消</el-button>
                                </div>
                            </div>


                        </div>
                        <div class="dx-dx-btn">
                            <el-button class="form-item-btn" size="small" plain v-show="!this.multiFlag" @click="showMoreCountry">{{bt1}}<i :class="iconType"></i></el-button>
                            <el-button class="form-item-btn" size="small" plain v-show="!this.radioFlag" @click="multiSelect">多选<i class="el-icon-plus el-icon--right"></i></el-button>
                        </div>
                    </el-form-item>

                    <!--                    <el-form-item label="物流方式:">-->
                    <!--                        <el-radio-group v-model="form.logisType" v-show="defaultFlag" class="hide_input">-->
                    <!--                            <el-radio label="all">全部</el-radio>-->
                    <!--                            <el-radio label="0">Amazon-a8589783@163.com-美国站-Standard-标准配送</el-radio>-->
                    <!--                            <el-radio label="1">其他</el-radio>-->
                    <!--                        </el-radio-group>-->
                    <!--                    </el-form-item>-->
                    <div class="ord-div-input">
                        <el-form-item label="平台订单号:" style="width: 33%;" class="normal-input">
                            <el-input size="small" v-model="form.eAppNo" placeholder="请输入平台订单号，多个平台订单号用英文逗号隔开"></el-input>
                        </el-form-item>

                        <el-form-item label="XXX订单号:" style="width: 33%;" class="normal-input">
                            <el-input size="small" v-model="form.sAppNo" placeholder="请输入XXX订单号，多个XXX订单号用英文逗号隔开"></el-input>
                        </el-form-item>

                        <el-form-item label="平台SKU:" style="width: 33%;" class="normal-input">
                            <el-input size="small" v-model="form.eSku" placeholder="请输入平台SKU，多个平台SKU用英文逗号隔开"></el-input>
                        </el-form-item>
                    </div>
                    <div class="ord-div-input">

                        <el-form-item label="匹配SKU:" style="width: 33%;" class="normal-input">
                            <el-input size="small" v-model="form.sSku" placeholder="请输入匹配SKU，多个匹配SKU用英文逗号隔开"></el-input>
                        </el-form-item>
                        <el-form-item label="收件人:" style="width: 33%;" class="normal-input">
                            <el-input size="small" v-model="form.cons" placeholder="请输入收件人姓名"></el-input>
                        </el-form-item>
                    </div>

                    <div class="order-form-sear-btn">
                        <el-button size="small" @click="resetForm">重置</el-button>
                        <el-button size="small" type="primary" @click="search">搜索</el-button>
                    </div>
                </div>
                <div class="pad-top-10">
                    <el-form-item label="排序方式:">
                        <el-radio-group v-model="form.sortord" @change="sortordChange" class="hide_input sort-group" >
                            <!--<el-radio label="0">按产品SKU<i class="el-icon-caret-top" @click="turnWay"></i></el-radio>-->
                            <el-radio label="ORDER_TIME">按下单时间<i class="el-icon-caret-top" @click="turnWay"></i></el-radio>
                            <el-radio label="REQ_DELI_TIME">按剩余发货时间<i class="el-icon-caret-top" @click="turnWay"></i></el-radio>
                            <el-radio label="ACT_PAY">按订单金额<i class="el-icon-caret-top" @click="turnWay"></i></el-radio>
                            <el-radio label="PAY_TIME">按付款时间<i class="el-icon-caret-top" @click="turnWay"></i></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="div-plan">
            <div class="btn_1">
                <el-dropdown size="small" style="padding-left: 10px" @command="exportOrder">
                    <el-button size="small" type="primary">
                        导出订单<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" >
                        <el-dropdown-item command="0">导出选中订单</el-dropdown-item>
                        <el-dropdown-item command="1">导出全部订单</el-dropdown-item>
                        <!--                        <el-dropdown-item command="2">按模板导出</el-dropdown-item>-->
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="fh-tab">
            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    @pagination="getList"
            />
            <el-table row-key="id" :data="orderData" :span-method="arraySpanMethod" default-expand-all @selection-change="tableSelectionChange" header-cell-class-name="table-header">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="商品信息" header-align="center" align="left"  prop="trackNo"></el-table-column>
                <el-table-column type="expand">
                    <template scope="props">
                        <table class="fh-inner-tab">
                            <tr>
                                <td>
                                    <div style="display: flex;margin: 10px 0 0 10px" v-for="item in props.row.orderSku">
                                        <el-popover placement="right" width="300" trigger="hover" :disabled="item.picAddr == null">
                                            <div style="text-align: right;background-color: rgba(239,239,239,1);height: 25px;line-height: 25px">
                                                <span style="padding-right: 20px">添加来源</span>
                                            </div>
                                            <img  class="img-big" :src="item.picAddr" style="width: 300px;height: 300px"/>
                                            <img v-if="item.picAddr != null" slot="reference" class="img-small" :src="item.picAddr" style="width: 70px;height: 70px;padding: 1px;border: 1px solid #EBEEF5"/>
                                            <img v-else slot="reference" class="img-small" src="../../assets/images/kong.png" style="width: 70px;height: 70px;padding: 1px;border: 1px solid #EBEEF5"/>
                                            <br/>
                                            <el-dropdown slot="reference" size="mini" class="orderList-el-dropdown" trigger="click" >
                                                  <span class="el-dropdown-link" v-show="!props.row.manualFlag">
                                                    来源<i class="el-icon-caret-bottom el-icon--right"></i>
                                                  </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item disabled >平台产品</el-dropdown-item>
                                                    <el-dropdown-item class="product-source" divided>来源1: 1688</el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </el-popover>
                                        <div style="font-size: 13px;text-align: left;width: 120px">
                                            <el-row class="order-sku" style="display: flex;align-items: center"><a href="javascript:void(0)" style="text-decoration: none;word-break: break-all">{{item.skuName}}</a><span>×</span><div class="p-num">{{item.num}}</div></el-row>
                                            <el-row>{{props.row.coinType}} {{item.price}}</el-row>
                                            <!--                                            <el-row>Color Pink</el-row>-->
                                            <!--                                            <el-row>Size：Int: One size</el-row>-->
                                        </div>
                                    </div>

                                </td>
                                <td style="width: 119px"> <span>{{props.row.proPri}}</span></td>
                                <td style="width: 234px;text-align: left"> <span>{{props.row.cons}} 「{{props.row.country}}」</span></td>
                                <td style="width: 140px;text-align: left">
                                    <div style="color: #409eff;width: inherit;word-break: break-all">{{props.row.sAppNo}}</div>
                                    <el-tooltip :content="props.row.orderRemark" placement="bottom" effect="light">
                                        <el-tag class="tag-bz" v-if="props.row.orderRemark">备</el-tag>
                                    </el-tooltip>
                                </td>
                                <td style="width: 180px">
                                    <span>下单:{{props.row.orderTime}}</span><br/>
                                    <span>付款:{{props.row.payTime}}</span>
                                </td>
                                <td style="width: 120px;font-size: 12px">
                                    <span v-if="props.row.expreMode == null">
                                        <span style="color: red;">物流方式未选择</span><br>
                                        <a style="color: #05B2D2" href="#" @click="showDetail(props.row,'3')">请选择物流方式</a>
                                    </span>
                                    <span v-else>{{props.row.expreMode}}</span>
                                </td>
                                <td style="width: 100px;font-size: 12px">
                                    <span v-if="props.row.sOrderStatus == '4'">已付款</span>
                                    <span v-if="props.row.sOrderStatus == '5'">已处理</span>
                                </td>
                                <td class="inner-tab-btn" style="width: 97px">
                                    <div v-if="props.row.sOrderStatus == '4'" ><el-button type="text" size="mini" @click="processOrder(props.row)">处理</el-button></div>
                                    <div v-if="props.row.sOrderStatus == '5'"><el-button type="text" size="mini" @click="applyWaybill(props.row)">申请运单号</el-button></div>
                                    <div v-if="props.row.sOrderStatus == '6'"><el-button type="text" size="mini" @click="printOrder(props.row)">打印面单</el-button></div>
                                    <div v-if="props.row.sOrderStatus == '6'"><el-button type="text" size="mini" @click="showDetail(props.row,'1')">移入待发货</el-button></div>
                                    <div v-if="props.row.sOrderStatus == '7'"><el-button type="text" size="mini" @click="showDetail(props.row,'1')">发货</el-button></div>
                                    <div v-if="props.row.sOrderStatus == '4' || props.row.sOrderStatus == '5'"><el-button type="text" size="mini" @click="addNote(props.row)">备注</el-button></div>
                                    <div><el-button  type="text" size="mini" @click="showDetail(props.row,'1')">详情</el-button></div>
                                </td>
                            </tr>
                        </table>
                    </template>
                </el-table-column>


                <el-table-column label="订单金额" align="center" width="120"></el-table-column>
                <el-table-column label="收件人【国家/地区】" align="center" width="240"></el-table-column>
                <el-table-column label="订单号" align="center" width="140"></el-table-column>
                <el-table-column label="时间" align="center" width="180"></el-table-column>
                <el-table-column label="物流方式" align="right" header-align="center" width="120">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.manualFlag">「 {{scope.row.eName}} : {{scope.row.shopName}} 」</span>
                        <span v-else>「 手工订单 」</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center"width="100">

                </el-table-column>
                <el-table-column label="操作"  align="center" width="100"></el-table-column>
            </el-table>
            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    @pagination="getList"
            />
        </div>
        <orderDetail :dataMap="detailProps" ref="orderDetail" class="order-detail"></orderDetail>
        <export-dialog :exportParam="exportParam"></export-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    import {getOrderList} from '@/api/order/all'
    import orderDetail from '../../components/order/orderDetail'
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {mapGetters} from 'vuex'
    import exportDialog from '@/components/order/exportDialog'
    export default {
        name: "allOrders",
        components:{
            orderDetail,Breadcrumb,exportDialog
        },
        data() {
            return {
                total:0,
                blackListVisible:false,
                activeName:'first',
                currentPage: 1,
                bt1:'更多',
                iconType:'el-icon-arrow-down el-icon--right',
                classManageDialog:false,//管理分类弹窗默认关闭
                form: {
                    pageNum: 1,
                    pageSize: 10,
                    channel:'all',//平台渠道
                    account:'all',//店铺账号
                    status:'6',//订单状态
                    country:'all',//国家区域
                    logisType:'all',//物流方式
                    sortord:'ORDER_TIME',//排序字段
                    byAsc:'desc',//升序或者降序
                    eAppNo:'',//平台订单号
                    sAppNo:'',//xx订单号
                    cons:'',//收件人姓名
                    eSku:'',
                    sSku:'',
                    manualFlag:'0',
                },
                blackListForm:{
                    cause:null
                },
                moreCountry:'0',
                fieldFilter:null,//更多国家过滤字段
                defaultFlag:true,//是否显示默认国家区域
                radioFlag:false,//是否显示单选国家区域框
                multiFlag:false,//是否显示多线国家区域框
                showMoreItem:false,
                dpList: ["店铺1", "店铺2", "店铺3", "店铺4", "店铺5", "店铺6", "店铺7" ],
                defaultCountries:['美国','加拿大','英国','法国','日本','德国','西班牙','巴西','澳大利亚','俄罗斯','荷兰','瑞典','比利时','挪威','智利','瑞士','乌克兰','伊朗','印度'],
                allCountries:{},
                countries:[],
                platList:[],
                accList:[],
                moreCountrySelect:[],//更多国家中选中的国家
                moreCountrySelect2:[],//更多国家中选中的国家
                checkedCountry:[],
                allSelectedCountry:[],
                rules:{cause:[{required: true, message: '请选择原因', trigger: 'blur'}]},
                orderData:[],
                option:[],
                multipleSelection:[],//表格中勾选的数据
                detailProps:{
                    visible:false,
                    title:''
                },
                exportParam:{
                    visible:false,
                    type:null,//0：导出勾选，1：导出全部
                    orderIds:[],//选中要导出的订单id（为空则导出全部订单）
                }
            }
        },
        computed:{
            ...mapGetters(['orderStatus','platCode','shopList']),
            //订单状态列表
            stateList(){
                return this.orderStatus;
            },
            userPlatList(){
                return this.platCode;
            },
            userShopList(){
                return this.shopList;
            }
        },
        created() {
            this.loadInitData();
            this.loadAllCountry();
            this.getList();
        },
        methods: {
            c_countryChange:function(val){
                $("#countryList .el-radio").each(function(){
                    if ($(this).find(".el-radio__label").text().indexOf(val) != -1) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            },
            shopChange(val){
                if(val == 'manual'){ //手工订单
                    this.form.manualFlag = '1';
                }else{
                    this.form.manualFlag = '0';
                }
                this.getList();
            },
            //获取订单列表数据
            getList(){
                console.log(this.form);
                getOrderList(this.form).then(res =>{
                    this.total = res.total;
                    this.orderData = res.rows;
                })
            },
            async loadInitData(){
                try{
                    let platDict;
                    await this.getDicts("s_plat_code").then(res => {
                        platDict = res.data;
                    });
                    let platCode = JSON.parse(JSON.stringify(this.$store.state.product.amazon.shopList));
                    platCode.map(code =>{
                        platDict.forEach(dict =>{
                            if(code.platNo == dict.dictValue){
                                code.platName = dict.dictLabel;
                            }
                        })
                    });
                    //获取所有平台代码
                    let data = [];
                    data.push({platNo:'all', platName:'全部', shopList:platCode})
                    platDict.forEach(dict => {
                        let map ={};
                        map.platNo = dict.dictValue;
                        map.platName = dict.dictLabel;
                        map.shopList = [];
                        platCode.forEach(code =>{
                            if(dict.dictValue == code.platNo){
                                map.shopList.push(code)
                            }
                        });
                        data.push(map);
                    });
                    this.platList = data.filter(item => {return item.shopList.length > 0});
                    this.accList = platCode;
                }catch (e) {
                    console.log(e)
                }
            },
            //1平台改变事件  2根据平台查询表格
            platChange(val){
                let data = this.platList.filter(item =>{
                    return item.platNo == val;
                })
                this.accList = data[0].shopList;
                this.form.channel =val;
                this.form.account ='all';
                this.getList();
            },
            countrySelChange:function(val){
                this.checkedCountry =val;
            },
            //已选国家/地区 再次勾选事件
            allSelectedCountryChange(val){
                this.moreCountrySelect2 = this.checkedCountry = val;
            },

            checkCountries:function(val) {
                if(val.length >=2){
                    // 删除索引为0的
                    let arrays = val.splice(0,val.length-1)
                }
            },
            saveMultiSelect:function(val){
                var that = this;
                var items =[];
                var ids=that.defaultCountries;
                var item1 = that.allSelectedCountry;
                item1.forEach((item) => {
                    if (ids.indexOf(item) == -1) {
                        ids.push(item);
                    }else{
                        items.push(item);
                    }
                    if (items.indexOf(item) == -1) {
                        items.push(item);
                    }
                    this.form.country =items;
                });
                this.multiFlag = false;
                this.defaultFlag  = true;
            },

            countrySelClick:function(val) {
                var that = this;
                var items =[];
                var ids = that.defaultCountries;
                if (items.indexOf(val) == -1) {
                    items.push(val);
                }
                if(ids.indexOf(val) == -1){
                    ids.push(val);
                }
                this.form.country = val;
                this.multiFlag = false;
                this.defaultFlag  = true;
                this.getList();
            },

            handleClick:function(){

            },
            showMoreCountry:function(){
                this.radioFlag = !this.radioFlag;
                this.defaultFlag = !this.radioFlag;
                if(this.radioFlag == true){
                    this.bt1 = '收起';
                    this.iconType='el-icon-arrow-up el-icon--right';
                }else{
                    this.bt1 = '更多';
                    this.iconType='el-icon-arrow-down el-icon--right';
                }
            },
            multiSelect:function(){
                this.multiFlag = true;
                this.defaultFlag  = false;
            },
            cancelMultiSelect:function(){
                this.multiFlag = false;
                this.defaultFlag  = true;
            },
            search: function() {
                this.getList();
            },
            resetForm:function(){
                this.form.eAppNo=[];
                this.form.sAppNo=[];
                this.form.eSku=[];
                this.form.sSku=[];
                this.form.cons=[];
            },
            sortordChange:function(val){
                /*$(".sort-up-down .el-radio").each((item) => {
                    console.log(item);
                });*/
                this.form.sortord =val;
                this.getList();
            },
            turnWay:function(e){
                var classVal =  e.target.className;
                if(classVal == 'el-icon-caret-top'){
                    e.target.setAttribute('class','el-icon-caret-bottom');
                    this.form.byAsc = 'asc';
                }else{
                    e.target.setAttribute('class','el-icon-caret-top');
                    this.form.byAsc = 'desc';
                }
                this.getList();
            },
            //标记黑名单
            markBlackList:function(){
                this.blackListVisible = true;
            },
            showDetail:function(row,activeTab){
                let params = {
                    appId:row.appId,
                    status:row.sOrderStatus
                }
                let platName = row.manualFlag?'手工订单':row.eName;
                this.detailProps.visible=true;
                this.detailProps.title = '包裹 「 '+ row.trackNo + ' 」详情 - 来源于「'+platName+'」';
                this.detailProps.activeTab = activeTab;
                //加载订单详情数据
                this.$refs.orderDetail.loadOrderDetail(params);
            },
            handleSelectionChange: function(val) {
                var ids = [];
                val.forEach((item) => {
                    if (ids.indexOf(item.id) == -1) {
                        ids.push(item.id);
                    }
                });
                this.$message({
                    message: '选择提示:已选择' + ids.length + '条',
                    center: true,
                    offset: 200
                });

            },
            //合并列
            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
                if (columnIndex === 1) {
                    return [1, 2];
                }else if(columnIndex === 2 ){
                    return [0, 0];
                }

                if(columnIndex === 7){
                    return [1, 3];
                }else if(columnIndex === 8 ||columnIndex === 9){
                    return [0,0];
                }
            },
            getSpanArr(data) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
                        if (data[i]["id"] === data[i - 1]["id"]) {
                            this.spanArr[this.pos] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.pos = i;
                        }
                    }
                }
            },
            handleSizeChange: function(val) {
                console.log(`每页: ${val}条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            cancelTime: function() {
                this.$confirm('确定要 [取消发布吗]?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '取消成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消失败'
                    });
                });
            },
            loadAllCountry(){
                let that = this;
                $.ajax({
                    url:process.env.BASE_URL + 'country.json',
                    method:'get',
                    success:function (res) {
                        let all = [];
                        // res.map.forEach((value,key) =>{
                        //     all.concat(value);
                        // });
                        for(let key in res.map){
                            all = all.concat(res.map[key])
                        }
                        res.map['0'] = all;
                        that.allCountries = JSON.parse(JSON.stringify(res));
                        that.countries = that.allCountries.map['0'];
                    }
                })
            },
            moreCountryTypeChange(val){
                this.countries = this.allCountries.map[val];
            },
            tableSelectionChange(val){
                this.multipleSelection = val;
            },
            //导出订单
            exportOrder(val){
                //val =0 时 导出选中订单  1 导出全部订单 2 按模板导出
                if(val == 0){
                    if(!this.multipleSelection.length > 0){
                        this.$message.warning("请至少选择一个订单！");
                        return false;
                    }
                    this.exportParam.type = 0;
                    this.exportParam.visible = true;
                    let ids = [];
                    this.multipleSelection.forEach(item => {
                        ids.push(item.appId);
                    });
                    this.exportParam.orderIds = ids;
                }else if(val == 1){//导出全部订单
                    this.exportParam.type = 1;
                    this.exportParam.queryForm = this.form;
                    this.exportParam.visible = true;

                }else if(val == 2){

                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

    #printOrder{
        width: 100%;
    }
    .el-radio__label{font-size: 13px !important;}
    .orderList-el-dropdown{display: flow-root;font-size: 13px}
    .product-source{text-align: right}
    .el-dropdown-menu{margin-top: 5px !important;}


</style>
